module.exports = __webpack_public_path__ + "img/头部背景@2x.e1dbfeef.png";